import React from 'react';
import AppActionMenu from '../../../../components/AppActionMenu';

export default function SalaryProcessTable({
  records = [],
  isLoading = false,
  onOpenPayslip,
  onRollback,
  onPostJournal,
  onProcessPayment,
  onResetFilters,
}) {
  const formatCurrency = (val) => {
    if (typeof val !== 'number') return '₹ 0.00';
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 2,
    }).format(val);
  };

  return (
    <div className="rounded-2xl border border-outline-variant/20 bg-surface-container-lowest overflow-hidden shadow-xs">
      <div className="overflow-x-auto">
        <div className="min-w-[1100px]">
          {/* Table Header Row matching legacy DAL GetGridviewList */}
          <div className="grid grid-cols-[80px_110px_110px_1fr_90px_150px_150px_150px_48px] items-center px-6 py-3.5 border-b border-outline-variant/25 bg-[#d9d9d9]/60 text-xs font-bold uppercase tracking-[0.08em] text-on-surface-variant select-none">
            <div>ID</div>
            <div>Month</div>
            <div>ID Card</div>
            <div>Name</div>
            <div>Emp ID</div>
            <div className="text-right">Total Earnings</div>
            <div className="text-right">Total Deductions</div>
            <div className="text-right">Net Amount</div>
            <div className="text-right"></div>
          </div>

          {/* Table Body Rows */}
          <div className="flex flex-col divide-y divide-outline-variant/10">
            {isLoading ? (
              <div className="px-6 py-16 text-center text-xs text-on-surface-variant font-semibold flex items-center justify-center gap-2">
                <span className="material-symbols-outlined text-xl animate-spin text-primary">
                  progress_activity
                </span>
                Loading salary records...
              </div>
            ) : records.length === 0 ? (
              <div className="px-6 py-16 text-center text-xs text-on-surface-variant font-semibold space-y-3">
                <span className="material-symbols-outlined text-4xl text-on-surface-variant/40 block">
                  receipt_long
                </span>
                <p>No salary records found for the selected period.</p>
                {onResetFilters && (
                  <button
                    type="button"
                    onClick={onResetFilters}
                    className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-xl bg-surface-container-high hover:bg-surface-container-highest text-primary font-bold text-xs transition cursor-pointer"
                  >
                    <span className="material-symbols-outlined text-sm">restart_alt</span>
                    <span>Reset Filters</span>
                  </button>
                )}
              </div>
            ) : (
              records.map((row) => (
                <div
                  key={row.id || `${row.empId}-${row.month}`}
                  className="grid grid-cols-[80px_110px_110px_1fr_90px_150px_150px_150px_48px] items-center px-6 py-4 hover:bg-surface-container-low/40 transition-colors text-xs text-on-surface group"
                >
                  {/* ID */}
                  <div className="font-mono text-on-surface-variant/80 font-bold select-text">
                    #{row.id}
                  </div>

                  {/* Month */}
                  <div className="font-bold text-primary select-text">
                    {row.month}
                  </div>

                  {/* IDCard */}
                  <div className="font-mono font-semibold text-on-surface-variant select-text">
                    {row.idCard}
                  </div>

                  {/* Name + Dept badge */}
                  <div className="font-bold select-text flex items-center gap-2 pr-3 min-w-0">
                    <span className="truncate">{row.name}</span>
                    {row.departmentName && (
                      <span className="text-[10px] font-semibold text-on-surface-variant/80 bg-surface-container-high px-2 py-0.5 rounded-md shrink-0">
                        {row.departmentName}
                      </span>
                    )}
                  </div>

                  {/* Emp ID */}
                  <div className="font-mono text-on-surface-variant select-text">
                    {row.empId}
                  </div>

                  {/* TotalEarnings */}
                  <div className="text-right font-bold text-emerald-700 select-text tabular-nums pr-1">
                    {formatCurrency(row.totalEarnings)}
                  </div>

                  {/* TotalDeductions */}
                  <div className="text-right font-bold text-rose-600 select-text tabular-nums pr-1">
                    {formatCurrency(row.totalDeductions)}
                  </div>

                  {/* NetAmount */}
                  <div className="text-right font-extrabold text-on-surface select-text tabular-nums pr-1">
                    {formatCurrency(row.netAmount)}
                  </div>

                  {/* Row Action 3-Dots Menu */}
                  <div className="flex justify-end select-none">
                    <AppActionMenu
                      triggerLabel=""
                      triggerIcon="more_vert"
                      showChevron={false}
                      triggerClassName="rounded-lg p-1.5 text-outline-variant transition-colors hover:bg-surface-container-high hover:text-primary bg-transparent cursor-pointer"
                      items={[
                        { key: 'payslip', label: 'View Payslip', icon: 'receipt_long' },
                        { key: 'print', label: 'Print Payslip', icon: 'print' },
                        { key: 'journal', label: 'Accounting Voucher', icon: 'currency_rupee' },
                        { key: 'payment', label: 'Payment Details', icon: 'payments' },
                        { key: 'rollback', label: 'Rollback Record', icon: 'history', danger: true },
                      ]}
                      onSelect={(key) => {
                        if (key === 'payslip' || key === 'print') {
                          onOpenPayslip?.(row);
                        } else if (key === 'journal') {
                          onPostJournal?.(row);
                        } else if (key === 'payment') {
                          onProcessPayment?.(row);
                        } else if (key === 'rollback') {
                          onRollback?.(row);
                        }
                      }}
                    />
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
